import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../components/breadcrumbs";
import Banner from "../../components/img_bannerblogs";
import RCMcy from "../../images/BlogCardImgs/Claim_denial.jpg";
import BlogImg7 from "../../images/BlogCardImgs/obtainingmedicalbillingservicesfromthebestmedical1.webp";
import BlogImg2 from "../../images/BlogCardImgs/choosingtooutsourceyourmedicalbillingisasmartdecision1.webp";
import BlogImg15 from "../../images/BlogCardImgs/managementofhealthcarerevenuecycle1.webp";
import BlogImg16 from "../../images/BlogCardImgs/detailsaboutpatientsareprotectedbyacer1.webp";
import Blogcontent from "../../img/Blogcontent1/proven_for_claim_aprovel.jpg";
import "../../css/testcard.css";
import { Helmet } from "react-helmet";
import Tablecontent from "../Blogs/Blogstablecontent";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";

import DownContact from "../../components/downcontact";

const About = () => {
  useEffect(() => {
    // change title of page
    document.title =
      "Proven Ways to Reduce Medical Billing Claim Denials and Boost Revenue";
  }, []);

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({
    title:
      "Proven Ways to Reduce Medical Billing Claim Denials and Boost Revenue",
    subtitle: "",
    img: `url(${RCMcy})`,
  });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({
    title: "WE HELP DOCTORS COLLECT MORE MONEY FASTER AND EASIER",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  });

  return (
    <>
      <Helmet>
        <style>{`body { overflow-x: hidden; }`}</style>
        <title>
          Reduce Claim Denials & Boost Revenue | AcerHealth Billing Tips
        </title>
        <link
          rel="canonical"
          href="https://acerhealth.com/blog/reduce-claim-denials"
        />
        <meta
          name="description"
          content="Discover expert strategies to reduce medical billing claim denials, boost cash flow, and streamline revenue cycle management with AcerHealth’s proven tips."
        />
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://www.acerhealth.com/blog/reduce-medical-billing-claim-denials"
        },
        "headline": "Proven Ways to Reduce Medical Billing Claim Denials and Boost Revenue",
        "description": "Discover expert strategies to reduce medical billing claim denials, improve cash flow, and streamline healthcare revenue cycle management with proven techniques from AcerHealth.",
        "image": "https://www.acerhealth.com/assets/images/reduce-medical-billing-denials-acerhealth.jpg",
        "author": {
          "@type": "Organization",
          "name": "AcerHealth",
          "url": "https://www.acerhealth.com"
        },
        "publisher": {
          "@type": "Organization",
          "name": "AcerHealth",
          "logo": "%PUBLIC_URL%/favicon.png"
        },
        "datePublished": "2025-04-23",
        "dateModified": "2025-04-23",
        "keywords": [
          "medical billing claim denials",
          "reduce claim denials",
          "healthcare revenue cycle",
          "billing denial management",
          "claims scrubbing process",
          "outsource medical billing"
        ]
      }
    `}
        </script>
      </Helmet>

      <Banner BannerTitle={BannerTitle} />
      <div className="container mb-4 mt-4 d-flex">
        <div style={{ maxWidth: "fit-content", width: "fit-content" }}>
          <BreadCrumbs
            paths={[
              { name: "Home", link: "/" },
              { name: "Blogs", link: "/medical-billing-blogs" },
              { name: "reduce-claim-denials" },
            ]}
          />
        </div>
      </div>
      <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
        <MDBCol md="3" className="toc-sticky">
          <Tablecontent />
        </MDBCol>
        <MDBCol md="7" className="content" style={{ paddingRight: "50px" }}>
          <h1
            style={{
              textAlign: "center",
              fontSize: "30px",
              fontFamily: "Alegreya Sans",
            }}
            className="mb-4"
          >
            <b>
              Proven Ways to Reduce Medical Billing Claim Denials and Boost
              Revenue
            </b>
          </h1>
          <div className="mb-3">
            <img
              src={Blogcontent}
              alt="Medical billing staff reviewing claims to reduce denials and improve revenue cycle using modern software"
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Medical billing claim denials are a significant challenge for
            healthcare providers, often resulting in lost revenue, delayed
            payments, and added stress. These denials can be caused by a variety
            of factors, including incorrect coding, missing information, and
            failure to meet insurance requirements. Reducing claim denials is
            essential not only for improving cash flow but also for maintaining
            patient satisfaction and minimizing administrative burden.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            This article takes a closer look at the most common reasons medical
            claims get denied and shares practical strategies to help prevent
            them. By spotting the root causes early and correcting issues before
            claims are submitted, healthcare providers can reduce denials,
            improve payment timelines, and keep day-to-day operations on track.
          </p>
          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>The Impact of Claim Denials on Healthcare Operations</b>
          </h2>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Claim denials can cause serious problems for healthcare providers.
            They don’t just lead to lost payments — they also take up a lot of
            staff time to fix mistakes that could’ve been avoided. Plus,
            patients often feel upset and confused when their insurance refuses
            to pay for services they thought were covered.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            That’s why it’s so important to prevent claim denials before they
            happen. With the right processes in place, many of these issues can
            be avoided. This not only saves time and money but also helps create
            a smoother experience for both staff and patients — reducing
            frustration and allowing healthcare teams to focus more on care.
          </p>
          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>
              Common Reasons and Billing Mistakes That Lead to Claim Denials
            </b>
          </h2>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Understanding why medical claims get denied is the first step in
            avoiding them. Often, it’s a mix of simple mistakes and overlooked
            insurance requirements that cause denials. Let’s break down the
            common reasons these issues happen and how small billing errors can
            make things worse.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>1. Incorrect Patient Information</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            It’s easy to overlook a small typo in a patient’s name, address, or
            insurance ID, but these little mistakes can lead to automatic claim
            rejections. Double-checking patient details before submitting claims
            is a simple way to avoid this issue.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>2. Missing Prior Authorization</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Certain services, especially expensive ones or specialized
            treatments, need approval from the insurance company before they can
            be provided. If that pre-approval is missed or delayed, the claim
            will likely be denied. Make sure prior authorization is handled in
            advance to keep things moving smoothly.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>3. Coding Errors</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Incorrect or outdated diagnosis and procedure codes are one of the
            top reasons for claim denials. It's crucial to use the most
            up-to-date coding systems, such as{" "}
            <b>
              ICD-10 (International Classification of Diseases, 10th edition)
            </b>{" "}
            and <b>CPT (Current Procedural Terminology) codes</b>.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            <a
              href="https://www.cms.gov/medicare/coding-billing/icd-10-codes"
              style={{ textDecoration: "underline" }}
            >
              The Centers for Medicare & Medicaid Services (CMS)
            </a>{" "}
            and the{" "}
            <a
              href="https://www.ama-assn.org/topics/cpt-codes"
              style={{ textDecoration: "underline" }}
            >
              American Medical Association (AMA)
            </a>{" "}
            are the authoritative sources for coding guidelines. These
            organizations regularly update coding systems to reflect changes in
            medical practices and technologies. Using outdated or incorrect
            codes can result in denials, as insurance companies may not
            recognize or approve the services provided.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            To avoid coding errors, it's essential to stay informed about
            changes in coding practices, attend training sessions, and use
            updated coding software that automatically pulls the latest codes.
            Ensuring proper alignment between diagnosis codes and procedure
            codes also helps minimize the risk of claim rejections.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>4. Duplicate Claims</b>
          </h3>
          <p
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Sometimes claims get submitted more than once by mistake. Whether
            it’s due to system errors or miscommunication, submitting the same
            claim multiple times will usually lead to a denial. A quick review
            before submitting can help catch these duplicates early.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>5. Expired or Inactive Insurance Coverage</b>
          </h3>
          <p
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            If a patient’s insurance coverage is no longer active when the
            service is provided, the claim will be denied. That’s why it’s so
            important to verify insurance eligibility before every visit. Using
            automated tools to check coverage in real-time makes this process
            faster and more accurate.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>6. Missing or Incorrect Provider Information</b>
          </h3>
          <p
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Simple mistakes like entering the wrong provider ID or forgetting to
            include required documents (like referral notes or lab results) can
            lead to claim denials. These issues often happen when the process is
            rushed or details are overlooked. Having a checklist can help ensure
            everything’s in order before submission.
          </p>
          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>Effective Ways to Prevent Claim Denials</b>
          </h2>
          <p
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Here are some effective strategies that can help reduce claim
            denials and improve billing accuracy:
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>1. Check Patient Insurance Before Each Visit</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Don’t wait until after services are rendered to check a patient’s
            insurance coverage. Use automated tools to verify active coverage
            and benefits in real-time before each visit. This can help ensure
            that services will be covered and reduce the likelihood of denials
            later.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>2. Train Staff on Common Denial Causes </b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Front-desk staff, medical assistants, and billing teams should be
            well-versed in the most common denial reasons. Regular training
            helps everyone stay informed about the latest updates in insurance
            requirements and billing protocols. Keeping staff updated on denial
            trends also helps improve overall efficiency.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>3. Use Up-to-Date Coding Tools</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Medical codes are regularly updated, and using outdated codes can
            result in denied claims. Ensure that your coders are using the
            latest ICD-10, CPT, and HCPCS codes. Integrating with modern coding
            software can help reduce manual errors and keep the process
            efficient.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>4. Automate the Claims Scrubbing Process</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Automated claims scrubbers can catch errors before submission. These
            systems flag missing data, incorrect codes, and other issues that
            might otherwise go unnoticed. By catching these problems early, you
            can fix them before they become costly denials.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>5. Track and Analyze Denial Trends</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Track denial reports regularly to identify patterns. Are denials
            increasing for certain services or payers? This data can help
            pinpoint recurring issues, so targeted improvements can be made.
            Additionally, analyzing denial trends allows for the development of
            proactive training and corrective measures.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>6. Implement Real-Time Claim Edits</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Many clearinghouses offer real-time claim edits that instantly
            detect issues before claims are even submitted to insurance. By
            utilizing these tools, billing teams have the opportunity to correct
            errors before they reach the payer, reducing the chances of denials.
          </p>
          <h3 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>7. Partner with a Professional Billing Company</b>
          </h3>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Outsourcing billing to a trusted provider can help cut down on
            billing errors and claim denials.{" "}
            <a href="/" style={{ textDecoration: "underline" }}>
              Medical billing companies
            </a>{" "}
            bring in-depth experience and up-to-date technology that ensure
            claims are submitted accurately and on time. By partnering with
            professionals, healthcare practices can minimize administrative
            stress and focus more on providing quality patient care, knowing
            their billing process is in good hands.
          </p>
          <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
            <b>Conclusion: Accuracy is Everything</b>
          </h2>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            Claim denials are a persistent issue for many healthcare providers,
            but they don’t have to be. By focusing on accuracy in billing,
            training staff, and embracing technology, healthcare organizations
            can reduce claim denials and{" "}
            <a
              href="/blog/best_practices_for_improving_revenue_cycle_management"
              style={{ textDecoration: "underline" }}
            >
              improve their revenue cycle management
            </a>
            . It’s important to stay proactive in identifying and addressing
            common billing errors and to keep improving systems for better
            results.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            At AcerHealth, we specialize in helping healthcare providers
            streamline their billing processes and reduce claim denials. With
            our experience, smart technology, and dedication to accuracy, we
            help practices get paid faster and reduce administrative burdens.
          </p>
          <p
            className=""
            style={{
              fontSize: "18px",
              fontFamily: "Alegreya Sans",
              fontWeight: "500",
            }}
          >
            If reducing your claim denials and improving your billing process is
            a priority,{" "}
            <a href="/contact-us" style={{ textDecoration: "underline" }}>
              contact Acer Health
            </a>{" "}
            today for a customized medical billing solution.
          </p>
          <br></br>

       
        </MDBCol>
        <MDBCol md="2" className="content" style={{ padding: "0px" }}>
          <MDBRow className="row-cols-1 row-cols-md-4 g-4">
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg7}
                    alt="Obtain Billing Services from the Best Medical Billing
                  Company"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="obtain_billing_services_from_the_best_medical_billing_company">
                        Obtain Billing Services from the Best Medical Billing
                        Company
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg2}
                    alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                        Choosing to Outsource Your Medical Billing is a Smart
                        Decision?
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg15}
                    alt="Management of the Healthcare Revenue Cycle"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="management_of_the_healthcare_revenue_cycle">
                        Management of the Healthcare Revenue Cycle
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard
                  className="cardtest1 p-0"
                  style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                >
                  <MDBCardImage
                    src={BlogImg16}
                    alt="Details about Patients is Protected by AcerHealth"
                    position="top"
                  />
                  <MDBCardBody>
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="details_about_patients_is_protected_by_acerhealth">
                        Details about Patients is Protected by AcerHealth
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBCol>
   <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>

   <MDBRow className="row-cols-1 row-cols-md-4 g-4 mb-2">
            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg7}
                  alt="Obtain Billing Services from the Best Medical Billing Company"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="obtain_billing_services_from_the_best_medical_billing_company">
                      Obtain Billing Services from the Best Medical Billing
                      Company
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg2}
                  alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                      Choosing to Outsource Your Medical Billing is a Smart
                      Decision?
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg15}
                  alt="Management of the Healthcare Revenue Cycle"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="management_of_the_healthcare_revenue_cycle">
                      Management of the Healthcare Revenue Cycle
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard
                className="cardtest1"
                style={{ backgroundColor: "#f0f4fb", height: "100%" }}
              >
                <MDBCardImage
                  src={BlogImg16}
                  alt="Details about Patients is Protected by AcerHealth"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div
                    className="cardtitletest"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: "bold" }}
                  >
                    <a href="details_about_patients_is_protected_by_acerhealth">
                      Details about Patients is Protected by AcerHealth
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>

   </div>



      </div>
      {/* <DownContact DownContactTitle={DownContactTitle} /> */}
    </>
  );
};

export default About;
